import React, { Component } from "react";
import "../css/style.css";
import { Link } from "react-router-dom";

export default class SideBar extends Component {
  state = {
    showLocation: false,
  };

  // Returns class string with 'active' appended when the path matches current URL
  getLinkClass = (path) => {
    const currentPath = window.location.pathname;
    const isActive = currentPath === path || currentPath.startsWith(path + "/");
    return `side-nav-link${isActive ? " active" : ""}`;
  };

  // Special handler for Location Management — stays active for all sub-routes
  getLocationLinkClass = () => {
    const currentPath = window.location.pathname;
    const locationPaths = [
      "/country-management",
      "/state-management",
      "/city-management",
    ];
    const isActive = locationPaths.some(
      (p) => currentPath === p || currentPath.startsWith(p + "/"),
    );
    return `side-nav-link${isActive ? " active" : ""}`;
  };

  showLocation = () => {
    if (this.state.showLocation === true) {
      this.setState({ showLocation: false });
    } else {
      this.setState({ showLocation: true });
    }
  };

  // Handle mobile sidebar close on route click
  handleMobileLinkClick = () => {
    // Close Location Management dropdown when navigating elsewhere
    if (this.state.showLocation) {
      this.setState({ showLocation: false });
    }
    if (this.props.closeSidebar && window.innerWidth <= 768) {
      this.props.closeSidebar();
    }
  };

  // For location sub-links — close mobile sidebar but keep dropdown open
  handleLocationSubLinkClick = () => {
    if (this.props.closeSidebar && window.innerWidth <= 768) {
      this.props.closeSidebar();
    }
  };

  render() {
    const { isMobileOpen } = this.props;

    return (
      <>
        {/* Mobile Overlay */}
        {isMobileOpen && (
          <div
            className="mobile-sidebar-overlay"
            onClick={this.props.closeSidebar}
          ></div>
        )}

        <div
          className={`left-side-menu left-side-menu-detached ${
            isMobileOpen ? "mobile-sidebar-open" : ""
          }`}
        >
          <div className="leftbar-user"></div>
          <ul className="metismenu side-nav">
            {/* ── CORE ENGINE ─────────────────────────── */}
            <li className="side-nav-title">Core Engine</li>

            <li className="side-nav-item">
              <Link
                to="/dashboard"
                className={this.getLinkClass("/dashboard")}
                id="main-sidebar"
                onClick={this.handleMobileLinkClick}
              >
                <i className="fa fa-tachometer"></i>
                <span>Dashboard Overview</span>
              </Link>
            </li>

            <li className="side-nav-item">
              <Link
                to="/user-management"
                className={this.getLinkClass("/user-management")}
                id="main-sidebar"
                onClick={this.handleMobileLinkClick}
              >
                <i className="fa fa-user"></i>
                <span>User Management</span>
              </Link>
            </li>

            <li className="side-nav-item">
              <Link
                to="/badge-management"
                className={this.getLinkClass("/badge-management")}
                id="main-sidebar"
                onClick={this.handleMobileLinkClick}
              >
                <i className="fa fa-hand-peace-o"></i>
                <span>Badge Management</span>
              </Link>
            </li>

            {/* ── CONTENT LIBRARY ─────────────────────── */}
            <li className="side-nav-title">Content Library</li>

            <li className="side-nav-item">
              <Link
                to="/story-management"
                className={this.getLinkClass("/story-management")}
                id="main-sidebar"
                onClick={this.handleMobileLinkClick}
              >
                <i className="fa fa-history" aria-hidden="true"></i>
                <span>Story management</span>
              </Link>
            </li>

            <li className="side-nav-item">
              <Link
                to="/poem-management"
                className={this.getLinkClass("/poem-management")}
                id="main-sidebar"
                onClick={this.handleMobileLinkClick}
              >
                <i className="fa fa-history" aria-hidden="true"></i>
                <span>Poem Management</span>
              </Link>
            </li>

            <li className="side-nav-item">
              <Link
                to="/video-management"
                className={this.getLinkClass("/video-management")}
                id="main-sidebar"
                onClick={this.handleMobileLinkClick}
              >
                <i className="fa fa-video-camera" aria-hidden="true"></i>
                <span>Multimedia Assets</span>
              </Link>
            </li>

            <li className="side-nav-item">
              <Link
                to="/category-management"
                className={this.getLinkClass("/category-management")}
                id="main-sidebar"
                onClick={this.handleMobileLinkClick}
              >
                <i className="fa fa-list" aria-hidden="true"></i>
                <span>Categories</span>
              </Link>
            </li>

            {/* <li className="side-nav-item">
              <Link
                to="/cms-management"
                className={this.getLinkClass("/cms-management")}
                id="main-sidebar"
                onClick={this.handleMobileLinkClick}
              >
                <i className="fa fa-database"></i>
                <span>CMS Management</span>
              </Link>
            </li> */}

            <li className="side-nav-item">
              <Link
                to="/language-management"
                className={this.getLinkClass("/language-management")}
                id="main-sidebar"
                onClick={this.handleMobileLinkClick}
              >
                <i className="fa fa-language" aria-hidden="true"></i>
                <span>Language Management</span>
              </Link>
            </li>

            {/* Location Management — dropdown */}
            <li className="side-nav-item">
              <Link
                to="/country-management"
                className={this.getLocationLinkClass()}
                id="main-sidebar"
                onClick={this.showLocation}
              >
                <i className="fa fa-location-arrow" aria-hidden="true"></i>
                <span>Location Management</span>
                <span
                  className="menu-arrow"
                  style={{
                    transform: this.state.showLocation
                      ? "rotate(90deg)"
                      : "rotate(0deg)",
                    transition: "transform 0.3s ease",
                    display: "inline-block",
                  }}
                ></span>
              </Link>
              {this.state.showLocation ? (
                <ul
                  className="side-nav-second-level"
                  aria-expanded="false"
                  ref={(content) => {
                    this.dropdownContent = content;
                  }}
                  style={{
                    padding: "0 0 0 30px",
                    margin: "0px",
                    listStyleType: "none",
                  }}
                >
                  <li style={{ padding: "5px 0" }}>
                    <Link
                      to="/country-management"
                      onClick={this.handleLocationSubLinkClick}
                      style={{
                        color: "#fff",
                        fontSize: "13px",
                        fontWeight: "600",
                      }}
                    >
                      Country Management
                    </Link>
                  </li>
                  <li style={{ padding: "5px 0" }}>
                    <Link
                      to="/state-management"
                      onClick={this.handleLocationSubLinkClick}
                      style={{
                        color: "#fff",
                        fontSize: "13px",
                        fontWeight: "600",
                      }}
                    >
                      State Management
                    </Link>
                  </li>
                  <li style={{ padding: "5px 0" }}>
                    <Link
                      to="/city-management"
                      onClick={this.handleLocationSubLinkClick}
                      style={{
                        color: "#fff",
                        fontSize: "13px",
                        fontWeight: "600",
                      }}
                    >
                      City Management
                    </Link>
                  </li>
                </ul>
              ) : null}
            </li>

            <li className="side-nav-item">
              <Link
                to="/thumbnail-management"
                className={this.getLinkClass("/thumbnail-management")}
                id="main-sidebar"
                onClick={this.handleMobileLinkClick}
              >
                <i className="fa fa-list"></i>
                <span>Thumbnail Management</span>
              </Link>
            </li>

            {/* <li className="side-nav-item">
              <Link
                to="/audio-management"
                className={this.getLinkClass("/audio-management")}
                id="main-sidebar"
                onClick={this.handleMobileLinkClick}
              >
                <i className="fa fa-volume-up" aria-hidden="true"></i>
                <span>Audio Management</span>
              </Link>
            </li> */}

            <li className="side-nav-item">
              <Link
                to="/for-you-management"
                className={this.getLinkClass("/for-you-management")}
                id="main-sidebar"
                onClick={this.handleMobileLinkClick}
              >
                <i className="fa fa-toggle-on" aria-hidden="true"></i>
                <span>For You Management</span>
              </Link>
            </li>

            {/* <li className="side-nav-item">
              <Link
                to="/movies-management"
                className={this.getLinkClass("/movies-management")}
                id="main-sidebar"
                onClick={this.handleMobileLinkClick}
              >
                <i className="fa fa-film" aria-hidden="true"></i>
                <span>Movies Management</span>
              </Link>
            </li> */}

            {/* ── EVENTS & SOCIAL ─────────────────────── */}
            <li className="side-nav-title">Events &amp; Social</li>

            <li className="side-nav-item">
              <Link
                to="/contest-management"
                className={this.getLinkClass("/contest-management")}
                id="main-sidebar"
                onClick={this.handleMobileLinkClick}
              >
                <i className="fa fa-trophy" aria-hidden="true"></i>
                <span>Contest Management</span>
              </Link>
            </li>

            <li className="side-nav-item">
              <Link
                to="/openmic-management"
                className={this.getLinkClass("/openmic-management")}
                id="main-sidebar"
                onClick={this.handleMobileLinkClick}
              >
                <i className="fa fa-microphone" aria-hidden="true"></i>
                <span>Open Mic Sessions</span>
              </Link>
            </li>

            <li className="side-nav-item">
              <Link
                to="/offline-openmic-management"
                className={this.getLinkClass("/offline-openmic-management")}
                id="main-sidebar"
                onClick={this.handleMobileLinkClick}
              >
                <i className="fa fa-microphone-slash" aria-hidden="true"></i>
                <span>Offline Open Mic</span>
              </Link>
            </li>

            <li className="side-nav-item">
              <Link
                to="/simple-events"
                className={this.getLinkClass("/simple-events")}
                id="main-sidebar"
                onClick={this.handleMobileLinkClick}
              >
                <i className="fa fa-calendar" aria-hidden="true"></i>
                <span>Simple Events</span>
              </Link>
            </li>

            <li className="side-nav-item">
              <Link
                to="/manage-meetings"
                className={this.getLinkClass("/manage-meetings")}
                id="main-sidebar"
                onClick={this.handleMobileLinkClick}
              >
                <i className="fa fa-calendar" aria-hidden="true"></i>
                <span>Manage Meetings</span>
              </Link>
            </li>

            <li className="side-nav-item">
              <Link
                to="/event-management"
                className={this.getLinkClass("/event-management")}
                id="main-sidebar"
                onClick={this.handleMobileLinkClick}
              >
                <i className="fa fa-list"></i>
                <span>Event Management</span>
              </Link>
            </li>

            <li className="side-nav-item">
              <Link
                to="/registeration-form"
                className={this.getLinkClass("/registeration-form")}
                id="main-sidebar"
                onClick={this.handleMobileLinkClick}
              >
                <i className="fa fa-trophy" aria-hidden="true"></i>
                <span>Event Registration Form</span>
              </Link>
            </li>

            <li className="side-nav-item">
              <Link
                to="/registeration-category"
                className={this.getLinkClass("/registeration-category")}
                id="main-sidebar"
                onClick={this.handleMobileLinkClick}
              >
                <i className="fa fa-trophy" aria-hidden="true"></i>
                <span>Registration Category</span>
              </Link>
            </li>

            {/* ── MARKETING ───────────────────────────── */}
            <li className="side-nav-title">Marketing</li>

            <li className="side-nav-item">
              <Link
                to="/new-spotlight"
                className={this.getLinkClass("/new-spotlight")}
                id="main-sidebar"
                onClick={this.handleMobileLinkClick}
              >
                <i className="fa fa-star-o" aria-hidden="true"></i>
                <span>Spotlight(Integrated)</span>
              </Link>
            </li>

            <li className="side-nav-item">
              <Link
                to="/notifications-management"
                className={this.getLinkClass("/notifications-management")}
                id="main-sidebar"
                onClick={this.handleMobileLinkClick}
              >
                <i className="fa fa-bell" aria-hidden="true"></i>
                <span>App Notifications</span>
              </Link>
            </li>

            <li className="side-nav-item">
              <Link
                to="/banner-management"
                className={this.getLinkClass("/banner-management")}
                id="main-sidebar"
                onClick={this.handleMobileLinkClick}
              >
                <i className="fa fa-image"></i>
                <span>Banners &amp; Homepage</span>
              </Link>
            </li>

            <li className="side-nav-item">
              <Link
                to="/simple-banner-management"
                className={this.getLinkClass("/simple-banner-management")}
                id="main-sidebar"
                onClick={this.handleMobileLinkClick}
              >
                <i className="fa fa-calendar" aria-hidden="true"></i>
                <span>Simple Banner</span>
              </Link>
            </li>

            <li className="side-nav-item">
              <Link
                to="/homepage-banner"
                className={this.getLinkClass("/homepage-banner")}
                id="main-sidebar"
                onClick={this.handleMobileLinkClick}
              >
                <i className="fa fa-trophy" aria-hidden="true"></i>
                <span>Homepage Banner</span>
              </Link>
            </li>

            <li className="side-nav-item">
              <Link
                to="/google-analytics"
                className={this.getLinkClass("/google-analytics")}
                id="main-sidebar"
                onClick={this.handleMobileLinkClick}
              >
                <i className="fa fa-bar-chart" aria-hidden="true"></i>
                <span>Analytics Dashboard</span>
              </Link>
            </li>

            <li className="side-nav-item">
              <Link
                to="/social-media"
                className={this.getLinkClass("/social-media")}
                id="main-sidebar"
                onClick={this.handleMobileLinkClick}
              >
                <i className="fa fa-share-alt" aria-hidden="true"></i>
                <span>Social Media</span>
              </Link>
            </li>

            {/* ── FINANCIALS ──────────────────────────── */}
            <li className="side-nav-title">Financials</li>

            <li className="side-nav-item">
              <Link
                to="/payment"
                className={this.getLinkClass("/payment")}
                id="main-sidebar"
                onClick={this.handleMobileLinkClick}
              >
                <i className="fa fa-credit-card" aria-hidden="true"></i>
                <span>Payments &amp; Subscriptions</span>
              </Link>
            </li>

            <li className="side-nav-item">
              <Link
                to="/subscription"
                className={this.getLinkClass("/subscription")}
                id="main-sidebar"
                onClick={this.handleMobileLinkClick}
              >
                <i className="fa fa-plus" aria-hidden="true"></i>
                <span>Subscription Management</span>
              </Link>
            </li>

            <li className="side-nav-item">
              <Link
                to="/plan"
                className={this.getLinkClass("/plan")}
                id="main-sidebar"
                onClick={this.handleMobileLinkClick}
              >
                <i className="fa fa-plus" aria-hidden="true"></i>
                <span>Plan Management</span>
              </Link>
            </li>

            <li className="side-nav-item">
              <Link
                to="/features"
                className={this.getLinkClass("/features")}
                id="main-sidebar"
                onClick={this.handleMobileLinkClick}
              >
                <i className="fa fa-plus" aria-hidden="true"></i>
                <span>Feature Management</span>
              </Link>
            </li>

            <li className="side-nav-item">
              <Link
                to="/app-version"
                className={this.getLinkClass("/app-version")}
                id="main-sidebar"
                onClick={this.handleMobileLinkClick}
              >
                <i className="fa fa-plus" aria-hidden="true"></i>
                <span>App Version</span>
              </Link>
            </li>

            <li className="side-nav-item">
              <Link
                to="/membership-plan"
                className={this.getLinkClass("/membership-plan")}
                id="main-sidebar"
                onClick={this.handleMobileLinkClick}
              >
                <i className="fa fa-plus" aria-hidden="true"></i>
                <span>Membership Plan (Deprecated)</span>
              </Link>
            </li>

            {/* ── SUPPORT ─────────────────────────────── */}
            <li className="side-nav-title">Support</li>

            <li className="side-nav-item">
              <Link
                to="/faqs-management"
                className={this.getLinkClass("/faqs-management")}
                id="main-sidebar"
                onClick={this.handleMobileLinkClick}
              >
                <i className="fa fa-question-circle"></i>
                <span>FAQs Management</span>
              </Link>
            </li>

            <li className="side-nav-item">
              <Link
                to="/courses"
                className={this.getLinkClass("/courses")}
                id="main-sidebar"
                onClick={this.handleMobileLinkClick}
              >
                <i className="fa fa-trophy" aria-hidden="true"></i>
                <span>Courses</span>
              </Link>
            </li>
          </ul>
        </div>
      </>
    );
  }
}
